<template>
  <v-pagination
    v-if="pagination.total > pagination.per_page"
    v-model="pagination.current_page"
    :length="pagination.last_page"
    @input="handlePagination"
  ></v-pagination>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    pagination: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    handlePagination() {
      this.$router.push({ query: { ...this.$route.query, page: this.page } });
    },
  },
  watch: {
    $route: {
      handler({ query }) {
        if (query.page) {
          this.pagination.current_page = query.page;
        }
      },
      immediate: true,
    },
  },
};
</script>

